import { careConsents } from '@lyrahealth-inc/shared-app-logic/src/features/assignments/constants'
import { AssignmentStatuses } from '@lyrahealth-inc/shared-app-logic/src/features/assignments/types'
import { getEffectiveRecipientLyraId } from '@lyrahealth-inc/shared-app-logic/src/features/assignments/utils'
import { Episode } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'

import { useAssignmentsData } from '../../../assignments/data/hooks/useAssignmentsData'
import { useSelectedEpisodeForClient } from '../../../episodes/data/hooks/useSelectedEpisodeForClient'

export const useCareConsent = () => {
  const { data: selectedEpisode } = useSelectedEpisodeForClient() as { data: Episode | undefined }
  const { data: assignments } = useAssignmentsData()

  const episodeCareConsents =
    assignments?.filter((assignment) => {
      return (
        assignment.episode_id === selectedEpisode?.id &&
        careConsents.includes(assignment.content.name) &&
        getEffectiveRecipientLyraId(assignment.recipient_id, assignment.patient_id || selectedEpisode?.patient_id) ===
          selectedEpisode?.patient_id
      )
    }) ?? []

  return (
    episodeCareConsents.find((assignment) => assignment.status === AssignmentStatuses.completed) ??
    episodeCareConsents[0]
  )
}
